import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { AgentDocument } from '../models/agents/agent-document';

export class CustomValidators {

    static isValidCNPJ() {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (control.value) {
                const document = new AgentDocument(control.value);
                document.isValid();
            }
            return null;
        };
    }

    static isValidCPF() {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (control.value) {
                const document = new AgentDocument(control.value);
                document.isValid();
            }
            return null;
        };
    }

    static isValidEmail() {
        return Validators.pattern(new RegExp(/(.+)@(.+){2,}\.(.+){2,}/));
    }
}
